<template>
    <div class="w_inner">
        <div class="con_box inner_banner">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide item" v-for="(item, index) in joinBanner">
                        <div class="img" :style="'background: url(' + item + ') center top no-repeat;height: 580px;'">
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
        <div class="innerWrap">
            <div class="main_container w">
                <div class="title wow fadeInUp animated" data-wow-delay=".4s">{{ $t('join.title') }}</div>
                <div class="joinFilter">
                    <SelectFilter :title="$t('join.city')" v-model="selected_jobcity" :options="list_jobcity">
                    </SelectFilter>
                    <SelectFilter :title="$t('join.post')" v-model="selected_jobpost" :options="list_jobpost">
                    </SelectFilter>
                </div>
                <div class="recruit_list">
                    <template v-if="total == 0">
                        <div class="nodataTips">{{ $t('join.tip') }}~</div>
                    </template>
                    <div class="list clearfix">
                        <ul>
                            <template v-for="(item, index) in join_list">
                                <li class="wow fadeIn animated" data-wow-delay="0.1s" :key="index">
                                    <router-link :to="{ name: 'joindetail', params: { id: item.id } }">
                                        <div class="tibar">{{ item.title }}</div>
                                        <div class="subti">{{ item.subTitle }}</div>
                                        <div class="desc">
                                            <div class="conTi">{{ $t('join.description') }}</div>
                                            <div class="textCon">
                                                {{ item.zhaiyao }}
                                            </div>
                                        </div>
                                    </router-link>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <pagination v-model="pageindex" :total="total" :pagesize="pagesize"></pagination>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { Loading } from 'element-ui';
import { mapState } from 'vuex'
import WOW from "../../node_modules/wowjs/dist/wow";
import SelectFilter from '../components/common/FlatSelectFilter.vue';
import pagination from '../components/common/Pagination.vue';
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
export default {
    data() {
        return {
            list_jobcity: [],
            selected_jobcity: '',
            list_jobpost: [],
            selected_jobpost: '',
            total: 0,
            pageindex: 1,
            pagesize: 6,
            join_list: [],
            joinBanner: []
        }
    },
    computed: {
        ...mapState({
            CompanyInfo: state => state.CompanyInfo
        })
    },
    components: {
        pagination,
        SelectFilter,
        [Loading.name]: Loading,
    },
    mounted() {
        //滚动页面加载动画
        let wow = new WOW.WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
        document.documentElement.scrollTop = 0;
        var _this = this;
        this.$nextTick(function () {
            var swiper = new Swiper(".swiper-container", {
                loop: true,
                slidesPerView: "auto",
                speed: 600,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });

        });

    },
    created() {
        this.GetList();
        this.GetCityList();
        this.GetPostList();
        this.joinBanner = this.CompanyInfo.joinBg.split(',');
    },
    methods: {
        GetCityList() {
            var url = "/pageapi/Common/GetFieldDic";
            var _name = this.$i18n.locale == 'zh' ? 'JobCity' : 'EnJobCity';
            var _allText = this.$i18n.locale == 'zh' ? '全部' : 'All';
            this.$http.post(url, { name: _name }).then((res) => {
                if (res.data.status == 1) {
                    var list_temp = [{ item: _allText, value: '' }];
                    res.data.ds.map((_item) => {
                        list_temp.push({ item: _item.item, value: _item.value });
                    });
                    this.list_jobcity = list_temp;
                }
            });
        },
        GetPostList() {
            var url = "/pageapi/Common/GetFieldDic";
            var _name = this.$i18n.locale == 'zh' ? 'JobPost' : 'EnJobPost';
            var _allText = this.$i18n.locale == 'zh' ? '全部' : 'All';
            this.$http.post(url, { name: _name }).then((res) => {
                if (res.data.status == 1) {
                    var list_temp = [{ item: _allText, value: '' }];
                    res.data.ds.map((_item) => {
                        list_temp.push({ item: _item.item, value: _item.value });
                    });
                    this.list_jobpost = list_temp;
                }
            });
        },
        GetList() {
            var url = "/pageapi/Job/GetList";
            this.$http.post(url, { pageindex: this.pageindex, pagesize: this.pagesize, City: this.selected_jobcity, Post: this.selected_jobpost }).then(function (res) {
                if (res.data.status == 1) {
                    this.join_list = res.data.ds;
                    this.total = res.data.total;
                    this.$nextTick(function () {
                        this.Initwow();
                    });
                }
            }.bind(this)).catch(function () {
            });
        },
        Initwow() {
            let wow = new WOW.WOW({
                boxClass: "wow",
                animateClass: "animated",
                offset: 0,
                mobile: true,
                live: true
            });
            wow.init();
        },
        PropsChange() {
            if (this.pageindex != 1) {
                this.pageindex = 1;
            } else {
                this.GetList();
            }
        },
    },
    watch: {
        pageindex: function () {
            this.GetList();
        },
        selected_jobcity() {
            this.PropsChange();
        },
        selected_jobpost() {
            this.PropsChange();
        },
    }
}
</script>
